<template>
  <div>
    <v-row v-if="form.id">
      <v-col cols="12" sm="6" md="7">
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title> Dados Pessoais </v-card-title>
              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Titulo </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.designation }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Data de Nascimento </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ formatDate(form.birth_date) }} ({{
                        getYearsOld(form.birth_date)
                      }}
                      anos)
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> CNPJ </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.cnpj || "N/A" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> RG </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.rg || "N/A" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> CPF </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.cpf || "N/A" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Email </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.email }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Telefone </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.phone_number }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-card-title> Administrativo </v-card-title>
              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Data de início </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ formatDate(form.started_at) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Observações </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.observation || "Nenhuma" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-card-title> Pagamento </v-card-title>
              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Salário </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ show_income ? form.income : "******" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn @click="show_income = !show_income" icon>
                      <v-icon v-if="!show_income"> mdi-eye </v-icon>
                      <v-icon v-else> mdi-eye-off </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> PIX </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.pix }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card>
              <v-card-title> Endereço </v-card-title>
              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> País </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.country }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> CEP </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.postal_code || "N/A" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Estado </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.state_address }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Cidade </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.city_address }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Bairro </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.neighborhood || "N/A" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Endereço </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.address }}, {{ form.address_number }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Complemento </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.address_complement || "Nenhum" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card>
              <v-card-title> Credenciais </v-card-title>
              <v-list v-if="form.user" dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Email </v-list-item-title>
                    <v-list-item-subtitle>
                      <router-link :to="`/users/${form.user.id}`">
                        {{ form.email }}
                      </router-link>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Nome </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.user.name }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Status </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.user.is_active ? "Ativo" : "Bloqueado" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Tipo </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ form.user.is_admin ? "Administrador" : "Padrão" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card>
              <v-card-title> Avançado </v-card-title>
              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Criado em </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ formatDateTime(form.created_at) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title> Última atualização </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ formatDateTime(form.updated_at) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title class="red--text">
                Excluir Profissional
              </v-card-title>
              <v-card-text>
                Excluir o profissional e todas as suas referências do sistema.
              </v-card-text>
              <v-card-actions>
                <v-btn @click="destroyProfessional()" color="red" dark
                  >Excluir Profissional</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DateTimeMixin from "@/mixins/DateTimeMixin";
import { show, destroy } from "@/services/professionals";

export default {
  data() {
    return {
      show_income: false,
    };
  },
  mixins: [DateTimeMixin],
  computed: {
    form: function () {
      return this.$store.getters["professional/getForm"];
    },
  },
  methods: {
    async destroyProfessional() {
      this.$store.dispatch("confirm_dialog/confirm", {
        title: "Excluir profissional",
        description: "Tem certeza que deseja excluir o profissional?",
        positive_action: async () => {
          await destroy(this.$route.params["id"]);
          this.$router.replace("/admin/professionals");
        },
      });
    },
    getYearsOld(birth_date) {
      const birth = this.$moment(birth_date);
      const today = this.$moment();

      return today.diff(birth, "years");
    },
  },
};
</script>